export default "__VITE_PUBLIC_ASSET__8918cf4a__"